<div class="dialog-overlay">
  <div class="orders-dialog">
    <div class="dialog-header">
      <h2 class="dialog-title">Change Location Orders</h2>
      <p class="subtitle">Moving to: {{ newLocation }}</p>
    </div>
    
    <div class="orders-container">
      <table class="orders-table" *ngIf="selectedOrders.length > 0">
        <thead>
          <tr>
            <th>Order</th>
            <th>Router/Urgency</th>
            <th>Frequency</th>
            <th>Order Time</th>
            <th>Report Time</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let order of selectedOrders">
            <td>{{ order.orderName }}</td>
            <td>{{ getUrgencyText(order.routeUrgencyId) }}</td>
            <td>{{ order.frequencyVal }}</td>
            <td>{{ order.orderTime || '-' }}</td>
            <td>{{ getReportTime(order) }}</td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="selectedOrders.length === 0" class="no-orders">
        No orders have been placed
      </div>

      <!-- Outpatient Appointment Section -->
      <div *ngIf="isOutpatientLocation" class="appointment-section">
        <h3>Appointment Details</h3>
        <div class="appointment-details">
          <div class="time-row">
            <span>Selected Time:</span>
            <span>{{ appointmentTime }}</span>
          </div>
          <button class="btn-schedule" (click)="onScheduleAppointment()">
            {{ selectedSimulationTime ? 'Change Time' : 'Schedule Appointment' }}
          </button>
        </div>
      </div>
    </div>

    <div class="dialog-actions">
      <button class="btn-cancel" (click)="onCancelMove()">Cancel</button>
      <button class="btn-confirm" 
              (click)="onConfirmMove()"
              [disabled]="isOutpatientLocation && !selectedSimulationTime">
        Confirm Move
      </button>
    </div>
  </div>
</div> 